import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import {IMultiTenant, ReactQueryKey} from "../../types";

interface IGetCouponParams {
    pickUpLocation: string,
    dropOffLocation: string,
    pickUpDate: string,
    dropoffDate: string,
    promoCode: string,
    carGroupCode: string | undefined,
    productCodes: string[],
    tenant: string,
    dealer: string
}

export interface IGetCouponReturn {
    message: string,
    leisureResult?: ILeisureResult | null,
    result?: string,
    code: string,
    codeServiceType: string
}

interface ILeisureResult {
    productList: IProductForCoupon[];
}

export interface IProductForCoupon {
    productName: string,
    productCode: string,
    startDate: string,
    endDate: string,
    status: string,
    category: string,
}

export const RESPONSE_CHECK_CODE = {
    SUCCESS: '00'
}

export const RESPONSE_TYPE_SERVICE = {
    leisure: 'LEISURE'
}

export const getCoupon = async (params: IGetCouponParams): Promise<IGetCouponReturn> => {
    const response = await axios.post('/booking/instool/check-code', params);
    return response.data;
};

export const useCouponQuery = (
    params?: Partial<IGetCouponParams>,
    options?: UseQueryOptions<IGetCouponReturn | null>
) => {
    return useQuery<IGetCouponReturn | null>(
        [ReactQueryKey.Coupon, {tenant: params?.tenant as string, dealer: params?.dealer as string}],
        () => {
            if (
                !params?.promoCode || !params?.tenant || !params?.dealer
            ) {
                return null;
            }
            return getCoupon({
                pickUpLocation: params?.pickUpLocation as string,
                dropOffLocation: params?.dropOffLocation as string,
                pickUpDate: params?.pickUpDate as string,
                dropoffDate: params?.dropoffDate as string,
                promoCode: params?.promoCode as string,
                carGroupCode: params?.carGroupCode,
                productCodes: params?.productCodes as string[],
                tenant: params?.tenant as string,
                dealer: params?.dealer as string
            });
        },
        options
    )
};

export const useCouponQueryObserver = (params?: IGetCouponParams | IMultiTenant) => {
    return useQuery<IGetCouponReturn>({
        queryKey: [ReactQueryKey.Coupon, {tenant: params?.tenant, dealer: params?.dealer}],
        enabled: false
    })
};
